<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!fixedassetSelected) {
        <h1 class="title">Crear {{ termKey.FixedAssetSingular | term }}</h1>
      }
    </div>
    <div class="title-color">
      @if (fixedassetSelected) {
        <h1 class="title">Editar {{ termKey.FixedAssetSingular | term }}</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="fixedassetForm" (ngSubmit)="savefixedAsset()">
        <div class="line">
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (fixedassetForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (fixedassetForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                placeholder="Descripción"
                formControlName="description"
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Vida útil</mat-label>
              <input
                type="number"
                matInput
                placeholder="Vida útil"
                formControlName="lifetime"
                maxlength="150"
              />
            </mat-form-field>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!fixedassetForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
